<template>
  <gg-modal :is-active="dialog" @close="close">
    <template v-slot:toolbar>
      Delete Access
    </template>
    <template v-slot:body>
      <p v-if="account">
        Are you sure you want to delete the access for “{{ accountData.email }} #{{ account }}” to
        “{{ serviceData.name }} #{{ service }}”?
      </p>
    </template>
    <template v-slot:actions>
      <gg-btn secondary @click="close">
        Cancel
        <span class="visually-hidden text-lowercase">button</span>
      </gg-btn>
      <gg-btn primary :loading="loading" @click="deleteAccess">
        Delete
        <span class="visually-hidden text-lowercase">button</span>
      </gg-btn>
    </template>
  </gg-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import modalMixin from '@/mixins/modal'

export default {
  name: 'DeleteAccessModal',
  mixins: [modalMixin],
  props: {
    account: {
      type: [String, Number],
      required: true,
    },
    service: {
      type: [String, Number],
      required: true,
    },
  },
  data () {
    return {
      loading: false,
    }
  },
  computed: {
    ...mapGetters(['accessApprovedList']),
    accountData () {
      return this.accessApprovedList.find(account => account.id == this.account)
    },
    serviceData () {
      return this.accountData.services.find(service => service.id == this.service)
    }
  },
  methods: {
    ...mapActions(['reportError', 'reportSuccess', 'deleteAccountAccess']),
    async deleteAccess () {
      this.loading = true
      try {
        const response = await this.deleteAccountAccess({
          account: this.account,
          service: this.service
        })
        this.reportSuccess(response.resultmsg)
      } catch (e) {
        this.loading = false
        this.reportError(e)
      }
      this.loading = false
      this.close()
    },
  },
}
</script>
